// extracted by mini-css-extract-plugin
export default {"icon":"icon--QXixs","functionality":"functionality--Pc0nM"};